<template>
  <div class="page-mouth">
    <div class="content">
      <div class="handerText">方法A：伍氏灯检查</div>
      <div class="body-box">
        <van-swipe
          ref="swiper"
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
        >
          <van-swipe-item>
            <img src="./../../assets/home/cbbj.png" alt="" />
          </van-swipe-item>
          <van-swipe-item>
            <img src="./../../assets/home/cbbj.png" alt="" />
          </van-swipe-item>
          <van-swipe-item>
            <img src="./../../assets/home/cbbj.png" alt="" />
          </van-swipe-item>
        </van-swipe>
        <div class="rightChange" @click="handleNextClick()">
          <van-icon name="arrow" color="#fff" size="19" />
        </div>
      </div>
      <div class="choose-box" v-if="1">
        <div class="choose-text">
          请选择符合图片情况的正确病变描述 （ 不定项选择题）：
        </div>
        <div
          :class="chooseIndex === index ? 'choose-active' : ''"
          class="choose-list"
          v-for="(item, index) in chooseList"
          @click="handleChooseClick(index)"
          :key="index"
        >
          <p>{{ item.title }}</p>
          <div>{{ item.text }}</div>
        </div>
      </div>
      <div v-else class="choose-no">腹部,无异常皮肤表现</div>
    </div>

    <div class="footer">
      <div class="btn">
        <div class="return" @click="handleSubmit">
          <img src="./../../assets/treat/submit.png" alt="" />
          <span>提交并进入下一题</span>
        </div>
      </div>
    </div>
    <mouthModal ref="modalRef"></mouthModal>
  </div>
</template>

<script>
import mouthModal from "./mouthModal.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "mouth",
  components: { mouthModal },
  data() {
    return {
      submitObj: {},
      chooseIndex: -1,
      chooseList: [
        {
          title: "A",
          text: "皮肤出现抓痕",
        },
        {
          title: "B",
          text: "皮肤有明显的糜烂",
        },
        {
          title: "C",
          text: "毛发稀疏",
        },
        {
          title: "D",
          text: "有少量结痂",
        },
      ],
      clientHeightFlag: true,
    };
  },
  computed: {
    ...mapState("visualExamination", [
      "mouthModalFlag",
      "selectPosition",
      "selectPositionObj",
    ]),
  },
  mounted() {
    if (document.documentElement.clientHeight >= 1038) {
      this.clientHeightFlag = false;
    } else {
      this.clientHeightFlag = true;
    }
  },
  watch: {
    selectPosition: {
      handler(val) {
        this.submitObj = val;
      },
      deep: true,
    },
  },
  created() {},
  methods: {
    ...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
    handleChooseClick(index) {
      this.chooseIndex = index;
    },
    handleSubmit() {
      if (this.mouthModalFlag) {
        const obj = {
          id: this.selectPositionObj.id,
          accomplish: true,
        };
        this.VISUAL_EXAMINATION({ key: "selectPositionObj", value: obj });
        this.$router.replace("/treat/point");
      } else {
        this.$refs.modalRef.handleShow();
      }
    },
    handleNextClick() {
      this.$refs.swiper.next();
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.page-mouth {
  width: 100%;
  min-height: 100vh;
  background-image: url("./../../assets/home/xwjBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  .handerText {
    width: 100%;
    text-align: center;
    font-size: 35px;
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    color: #ffffff;
    margin-bottom: 27px;
  }
  .content {
    flex: 1;
    width: 100%;
    padding: 31px 45px;
    // padding-top: 90px;
  }
  .body-box {
    width: 100%;
    height: 545px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    padding: 19px 23px;
    border-radius: 60px;
    position: relative;
    .my-swipe,
    .van-swipe-item,
    img {
      width: 100%;
      height: 100%;
      border-radius: 48px;
    }
  }
  .rightChange {
    width: 72px;
    height: 72px;
    opacity: 0.7;
    border-radius: 50%;
    background: #ab3b91;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 240px;
    right: 27px;
  }
  ::v-deep .van-swipe__indicator {
    width: 18px;
    height: 18px;
    background: #d2d2d2;
  }
  .choose-no {
    margin-top: 45px;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    padding: 40px 45px 40px 45px;
    width: 100%;
    height: 652px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 45px;
    font-family: HarmonyOS Sans SC;
    font-weight: bold;
    color: #ab3b91;
  }
  .choose-box {
    margin-top: 45px;
    width: 100%;
    height: auto;
    background: rgba(255, 255, 255, 0.5);
    box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
    border: 2px solid #ffffff;
    border-radius: 60px;
    padding: 40px 45px 40px 45px;
    .choose-text {
      font-size: 35px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #333333;
      line-height: 50px;
    }

    .choose-list {
      width: 100%;
      height: auto;
      background: #ffffff;
      box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
      border-radius: 40px;
      margin-top: 20px;
      font-size: 25px;
      font-family: HarmonyOS Sans SC;
      font-weight: 400;
      color: #4d4d4d;
      display: flex;
      align-items: center;
      padding: 28px 61px;
      p {
        position: relative;
        margin-right: 19px;
      }
      p::before {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 39px;
        content: "";
        width: 2px;
        height: 38px;
        background: #cccccc;
      }
      div {
        margin-left: 35px;
      }
    }
    .choose-active {
      box-shadow: 2px 3px 5px 0px rgba(14, 89, 145, 0.11);
      background: #ab3b91;
      color: #fff;
    }
    .choose-active > p::before {
      background: #fff;
    }
  }
  .footer {
    width: 100%;
    height: 183px;
  }
  .btnActive {
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .btn {
    width: 100%;
    height: 183px;
    background: linear-gradient(0deg, #ffffff, #e9f4f2);
    border-radius: 60px 60px 0px 0px;

    display: flex;
    align-items: center;
    justify-content: center;
    .return {
      width: 426px;
      height: 87px;
      background: linear-gradient(
        132.74deg,
        rgba(0, 187, 177, 1) 0%,
        rgba(0, 86, 140, 1) 74.31%,
        rgba(171, 59, 127, 1) 100%
      );
      border: 1px solid #ffffff;
      box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
      display: flex;
      border-radius: 60px;
      align-items: center;
      justify-content: center;
      img {
        width: 36px;
        height: 33px;
      }
      span {
        font-size: 35px;
        font-family: HarmonyOS Sans SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 59px;
      }
      span:nth-child(2) {
        margin-left: 25px;
      }
    }
  }
}
</style>
